// the reason this is a function is because the google.xxx object may not be ready
// when this file is imported
export default () => ({
  zoom: 14,
  minZoom: 10,
  maxZoom: 17,
  gestureHandling: 'greedy',
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  styles: [{
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.attraction',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.business',
    elementType: 'all',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.business',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.business',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }]
  }, {
    featureType: 'poi.government',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.school',
    elementType: 'all',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'poi.school',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{ visibility: 'on' }]
  }, {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ visibility: 'on' }]
  }]
});
